<template>
  <div class="visit">
    <!-- 搜索框 -->
    <FailureSearchBar
      @search="search"
      :checkList="checkList"
      @reload="fetchData"
    />

    <!-- 表单 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      @selection-change="handleSelectionChange"
      fit
      highlight-current-row
      height="660"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" width="60" label="编号">
        <template slot-scope="scope">
          {{ pageSize * (pageIndex - 1) + (scope.$index + 1) }}
        </template>
      </el-table-column>
      <el-table-column label="推荐人" align="center">
        <template slot-scope="scope">
          <span>{{ handledecrypt(scope.row.reward) || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="推荐人电话" align="center">
        <template slot-scope="scope">
          <span>{{
            handledecrypt(scope.row.mobile, scope.row.isShowAllPhone)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户姓名" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.customerName) || '--' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="客户电话" align="center">
        <template slot-scope="scope">
          {{
            handledecrypt(scope.row.customerPhone, scope.row.isShowAllPhone) ||
            '--'
          }}
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="客户身份证后6位"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.lastSixId || '--' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="租购意向" align="center">
        <template slot-scope="scope">
          <span>
            {{ scope.row.isSaleTxt || '--' }}
          </span>
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="客户意向房源"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.require || '--' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="企业名称" align="center">
        <template slot-scope="scope">
          {{ scope.row.companyName || '--' }}
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="已报备来源"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.source || '--' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="销售姓名" align="center">
        <template slot-scope="scope">
          {{ scope.row.salesPersonName || '--' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="提交时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.createTime || '' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="备注" align="center">
        <template slot-scope="scope">
          {{ scope.row.remark || '--' }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination
      ref="Pagination"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
    />

    <!-- 编辑客服人员 -->
    <editPerson ref="editPerson" @fetchData="fetchData"></editPerson>

    <!-- 修改状态 -->
    <changeStatus ref="changeStatus" @fetchData="fetchData" />

    <manualAllocation ref="manualAllocation" @fetchData="fetchData" />

    <el-dialog
      title="详情"
      class="detail"
      :visible.sync="detailShow"
      width="30%"
    >
      <div class="detail-row">
        <span>备注: </span>{{ detailObj.reviewOpinion }}
      </div>
      <div class="detail-row">
        <span>到访时间:</span> {{ detailObj.arriveTime }}
      </div>
      <div class="detail-row">
        <span> 签约时间:</span> {{ detailObj.signedTime }}
      </div>
      <div class="detail-row">
        <span> 成交类型:</span> {{ detailObj.type === 1 ? '购' : '租' }}
      </div>
      <div class="detail-row">
        <span> 单价:</span> {{ detailObj.unitPrice }}
      </div>
      <div class="detail-row">
        <span> 总佣金:</span> {{ detailObj.totalBonus }}
      </div>
      <div class="detail-row">
        <span> 成交金额:</span> {{ detailObj.totalPrice }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="detailShow = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { introduceFailRecordApi, searchSignedApi } from '@/api/introduce';
const changeStatus = () => import('./components/changeStatus'); // 增加表单
const editPerson = () => import('./components/editPerson'); // 增加表单
const manualAllocation = () => import('./components/manualAllocation');
import Pagination from '@/components/Pagination'; // 分页
import { mapGetters } from 'vuex';
import FailureSearchBar from './components/failureSearchBar'; // 搜索框
import { decrypt } from '@/utils/encryp';

export default {
  components: {
    changeStatus,
    editPerson,
    manualAllocation,
    Pagination,
    FailureSearchBar,
  },
  data() {
    return {
      list: null,
      listLoading: false,
      detailShow: false,
      // size和index用于计算编号
      pageSize: '',
      pageIndex: '',
      path: '',
      detailObj: {}, // 详情数据
      checkList: [], // 选中的列表
    };
  },
  created() {
    this.fetchData();
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },

  mounted() {
    document.querySelector('.el-table__body-wrapper').style.height = '580px';
  },
  computed: {
    // 'statusList', 'roleList'
    ...mapGetters(['paginObj']),
  },

  watch: {
    // 当分页组件中页码或页容量发生改变时会重新发请求渲染页面
    // paginObj: 'fetchData',
  },
  methods: {
    // 处理解密
    handledecrypt(str, isShowAllPhone = true) {
      // if (!str || str.indexOf('=') == -1) return str;
      let showStr = decrypt(str);
      return isShowAllPhone
        ? showStr
        : showStr.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    // 请求表单数据
    // searchBar会触发此方法
    async fetchData() {
      try {
        const areaId = localStorage.getItem('areaId')
          ? JSON.parse(localStorage.getItem('areaId')).areaId
          : '';
        this.listLoading = true;
        let res = await introduceFailRecordApi({
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          ...this.fromSearchObj,
          areaId,
        });
        this.listLoading = false;
        if (res.code !== 200 || res.data == null) return;
        let { pageSize, pageIndex, dataList, totalCount } = res.data;
        this.list = dataList;
        this.pageSize = pageSize;
        this.pageIndex = pageIndex;
        this.$refs.Pagination.pageSize = pageSize;
        this.$refs.Pagination.pageIndex = pageIndex;
        this.$refs.Pagination.totalCount = totalCount;
      } catch (e) {
        this.listLoading = false;
        window.console.log(e);
      }
    },

    // 搜索
    search(obj = {}) {
      if (obj) this.fromSearchObj = obj;
      console.log('查询字段：', this.fromSearchObj);
      this.fetchData();
      // 重置页码
      //   this.$store.dispatch('area/setPaginObj', {
      //     pageIndex: 1,
      //     pageSize: 20,
      //   });
    },
    handleSelectionChange(val) {
      this.checkList = val.map((item) => {
        return item.appFailRecordId;
      });
    },
    // 修改客服人员
    handleEditPerson(row) {
      // console.log(row);
      let { appRecordId, isSale, customerServiceName, customerServiceId } = row;
      this.$refs.editPerson.editForm.id = appRecordId;
      this.$refs.editPerson.editForm.isSale = isSale;
      this.$refs.editPerson.searchUser(customerServiceName);
      // a37a79c3-3642-4277-ab1f-793d5101ec14
      this.$refs.editPerson.editForm.customerServiceId = customerServiceId;
      this.$refs.editPerson.dialogFormVisible = true;
    },
    // 变更状态
    onChangeStatus(row) {
      this.$refs.changeStatus.dialogFormVisible = true;
      // this.$refs.changeStatus.value = [this.statusList[row.status]];
      // console.log('状态：', row.status, typeof row.status);
      this.$refs.changeStatus.childStatus = row.status;
      if (row.status === 4 || row.status === 6) {
        this.$refs.changeStatus.isTimeOut = true; //已失效或已过期变更需重新分配客服和销售
      }
      // console.log('row', row);
      this.$refs.changeStatus.editForm.opinion = row.remark;
      this.$refs.changeStatus.editForm.appRecordId = row.appRecordId;
    },

    // 人工分配
    handleDistritution(row) {
      this.$refs.manualAllocation.dialogFormVisible = true;
      // this.$refs.changeStatus.value = [this.statusList[row.status-1]]
      // this.$refs.changeStatus.editForm.opinion = row.remark
      this.$refs.manualAllocation.changeForm.appRecordId = row.appRecordId;
    },

    // 查看详情，只有已签约，可结佣，已结佣有这个功能
    async lookDetails(row) {
      await searchSignedApi(row.appRecordId).then((res) => {
        this.detailObj = res.data;
        if (this.detailObj) {
          // console.log(this.detailObj);
          this.detailShow = true;
        } else {
          this.$message.warning('暂无详情');
          // this.detailShow = false;
        }
      });
    },
    // 页面变化
    handleCurrentChange(obj) {
      this.paginObj.pageIndex = obj.pageIndex;
      this.fetchData();
    },
    // 分页改变页面数据
    handleSizeChange(obj) {
      this.paginObj.pageIndex = 1;
      this.paginObj.pageSize = obj.pageSize;
      this.fetchData();
    },
  },
};
</script>

<style lang="less" scoped>
.visit {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

/deep/ .el-checkbox__input {
  margin-left: 10px;
}
/deep/ .el-table__body-wrapper {
  height: 460px !important;
}
// 隐藏选择框的文字
/deep/ .el-checkbox__label {
  display: none;
}

.btn {
  margin-bottom: 10px;
}

.lookDetails {
  margin-top: 10px;
}

.detail {
  .detail-row {
    margin-top: 10px;
    display: flex;
    font-size: 16px;

    span {
      width: 100px;
      text-align: right;
      margin-right: 20px;
      font-weight: 550;
    }
  }
}
</style>
